(ns frontend.view.components.form.components.form-numeric
  (:require [reagent.core :as r]
            [clojure.string :as string]
            [frontend.view.components.form.components.form-label :as form-label]
            [frontend.utils :as utils]
            [frontend.view.components.form.components.form-cancel-button :as cancel-button]
            [frontend.bootstrap.components :as rbs]))

(defn view
  [{:keys [value hide-cancel-button?]}]
  (let [raw-input (r/atom nil)
        has-focus (r/atom false)
        decimals (r/atom nil)
        negative? (r/atom false)
        flicker-timeout (r/atom nil)
        reset-raw-input! (fn [v]
                           (when @flicker-timeout
                             (.clearTimeout js/window @flicker-timeout)
                             (reset! flicker-timeout nil))
                           (reset! raw-input nil)
                           (reset! decimals -1)
                           (reset! negative? false))
        ]
    (fn [{:keys [label size value intelligence-value wrapper control-id read-only?
                 validate! on-change! on-submit! on-cancel!] :as view-args}]
      (let [on-cancel! (fn [e]
                         (reset-raw-input! nil)
                         (on-cancel! e))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (= key 13)
                               (-> e .-target .blur))       ;; Enter = blur -> save
                             (when (= key 27)               ;; Esc = cancel
                               (on-cancel! e)
                               (-> e .-target .blur))))
            on-submit! (fn [e]
                         (if (or (= @raw-input value)
                                 (nil? @raw-input))
                           (on-cancel! e)
                           (do
                             (on-change! (if (or (js/isNaN @raw-input)
                                                 (= "" @raw-input))
                                           nil
                                           @raw-input))
                             (on-submit! e)
                             (reset! flicker-timeout (.setTimeout js/window (partial reset-raw-input! nil) 2000)))))]
        [rbs/Form
         {:class-name "form-numeric-form"
          :on-submit  on-submit!
          :on-blur    (fn [e]
                        (let [targetType (-> e .-target .-nodeName)]
                          (when (= targetType "INPUT")
                            (on-submit! e))))}
         [rbs/FormGroup
          {:control-id control-id
           :size       size
           :class-name (str wrapper " form__text")}
          (when label
            [form-label/view view-args])
          [rbs/InputGroup
           [:input {:placeholder ""
                    :type        "text"
                    :id          control-id
                    :class-name  "form-control"
                    :disabled    (boolean read-only?)
                    :value       (or (let [draw-value (if (nil? @raw-input)
                                                        (or value intelligence-value)
                                                        @raw-input)
                                           min-decimal-count (if (nil? @raw-input) -1 @decimals)
                                           ;; in case @decimals is nil:
                                           min-decimal-count (or min-decimal-count -1)]
                                       (when draw-value
                                         (if (= draw-value "")
                                           (when @negative? "-")
                                           (string/trim (utils/format-with-separators draw-value min-decimal-count @negative?)))))
                                     "")
                    ;; append decimal when editing without decimals
                    :on-key-down on-key-down!
                    :on-blur     #(reset! has-focus false)
                    :on-focus    (fn [_]
                                   (reset-raw-input! nil)
                                   (reset! has-focus true))
                    :on-change   (fn [e]
                                   (let [input (-> e .-target .-value)
                                         float-value (utils/parse-float-info input "")]
                                     (reset! decimals (or (:decimal-count float-value) -1))
                                     (reset! negative? (or (:negative? float-value) false))
                                     (when validate!
                                       (validate! (:float-value float-value)))
                                     (reset! raw-input (:float-value float-value))))}]
           (when (and @has-focus (not hide-cancel-button?))
             [cancel-button/view on-cancel!])]]]))))
